<template>
  <bm-unit-base
    v-bind="$attrs"
    :value="value"
    :unit-preference="unitPreference"
    @update:value="emit('update:value', $event)"
  />
</template>

<script setup lang="ts">
import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import BmUnitBase from "@/components/controls/input/specialised/BmUnitBase.vue";

interface BmVolumeVesselsProps {
  value?: number | null;
}

interface BmVolumeVesselsEvents {
  (event: "update:value", value: number | null): void;
}

withDefaults(defineProps<BmVolumeVesselsProps>(), {
  value: null,
});

const emit = defineEmits<BmVolumeVesselsEvents>();

const unitPreference =
  tenantService.settings.displayUnitPreferences.vesselVolumes;
</script>
